import { LogLevel, PopupRequest } from '@azure/msal-browser';
import { getEnvVariables } from '@/env/getEnvVariables';
import { logError } from '@/utils/errorReporter';

export const authRequest: PopupRequest = {
  authority: getEnvVariables().auth.authFlow.authority,
  scopes: [getEnvVariables().auth.backendAuthScope],
};

export const msalConfig = {
  auth: {
    clientId: getEnvVariables().auth.clientId,
    authority: getEnvVariables().auth.authFlow.authority,
    knownAuthorities: [getEnvVariables().auth.knownAuthority],
    redirectUri: '/auth/chat',
    postLogoutRedirectUri: '/',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            logError('msal-auth-error', message, 'auth-config');
            return;
          default:
            return;
        }
      },
    },
  },
};
